// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neuroglancer-graphene-tab .neuroglancer-annotation-toolbox {
  display: none;
}

.neuroglancer-graphene-tab
  div[data-color="#ff0000"]
  > .neuroglancer-annotation-position {
  color: red;
}

.neuroglancer-graphene-tab
  div[data-color="#0000ff"]
  > .neuroglancer-annotation-position {
  color: #4444ff;
}

.graphene-multicut-status {
  display: flex;
  flex-direction: row;
}

.graphene-multicut-status > .activeGroupIndicator {
  padding: 2px;
  margin: auto 0;
  background-color: red;
  font: 12px sans-serif;
  font-weight: 900;
}

.graphene-multicut-status > .activeGroupIndicator.blueGroup {
  background-color: blue;
}

.graphene-multicut-status > .activeGroupIndicator::after {
  content: "Red";
}

.graphene-multicut-status > .activeGroupIndicator.blueGroup::after {
  content: "Blue";
}

.graphene-merge-segments-merges {
  display: flex;
  flex-direction: column;
}

.graphene-merge-segments-submission {
  display: flex;
  gap: 10px;
}

.graphene-merge-segments-status {
  display: flex;
  gap: 10px;
}

.graphene-merge-segments-status .neuroglancer-icon,
.graphene-multicut-status .neuroglancer-icon {
  height: 100%;
}

.graphene-merge-segments-status label {
  display: grid;
  grid-template-columns: min-content min-content;
  white-space: nowrap;
  justify-content: center;
  align-content: center;
}

.graphene-merge-segments-point {
  display: flex;
  align-items: center;
  gap: 10px;
}

.graphene-merge-segments-point
  .neuroglancer-segment-list-entry-visible-checkbox,
.graphene-merge-segments-point .neuroglancer-segment-list-entry-copy-container {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/datasource/graphene/graphene.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;EAGE,aAAa;AACf","sourcesContent":[".neuroglancer-graphene-tab .neuroglancer-annotation-toolbox {\n  display: none;\n}\n\n.neuroglancer-graphene-tab\n  div[data-color=\"#ff0000\"]\n  > .neuroglancer-annotation-position {\n  color: red;\n}\n\n.neuroglancer-graphene-tab\n  div[data-color=\"#0000ff\"]\n  > .neuroglancer-annotation-position {\n  color: #4444ff;\n}\n\n.graphene-multicut-status {\n  display: flex;\n  flex-direction: row;\n}\n\n.graphene-multicut-status > .activeGroupIndicator {\n  padding: 2px;\n  margin: auto 0;\n  background-color: red;\n  font: 12px sans-serif;\n  font-weight: 900;\n}\n\n.graphene-multicut-status > .activeGroupIndicator.blueGroup {\n  background-color: blue;\n}\n\n.graphene-multicut-status > .activeGroupIndicator::after {\n  content: \"Red\";\n}\n\n.graphene-multicut-status > .activeGroupIndicator.blueGroup::after {\n  content: \"Blue\";\n}\n\n.graphene-merge-segments-merges {\n  display: flex;\n  flex-direction: column;\n}\n\n.graphene-merge-segments-submission {\n  display: flex;\n  gap: 10px;\n}\n\n.graphene-merge-segments-status {\n  display: flex;\n  gap: 10px;\n}\n\n.graphene-merge-segments-status .neuroglancer-icon,\n.graphene-multicut-status .neuroglancer-icon {\n  height: 100%;\n}\n\n.graphene-merge-segments-status label {\n  display: grid;\n  grid-template-columns: min-content min-content;\n  white-space: nowrap;\n  justify-content: center;\n  align-content: center;\n}\n\n.graphene-merge-segments-point {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.graphene-merge-segments-point\n  .neuroglancer-segment-list-entry-visible-checkbox,\n.graphene-merge-segments-point .neuroglancer-segment-list-entry-copy-container {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
